var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
// TODO:: please, refactor me, please
import * as React from 'react';
import _get from 'lodash/get';
import _pick from 'lodash/pick';
import { translate } from 'react-i18next';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import Cookies from 'js-cookie';
import config from '../../../../config/app.config';
import loginForm from './formConfigs/LoginFormConfig';
import registerForm from './formConfigs/RegistrationFormConfig';
import updateProfileForm from './formConfigs/UpdateProfileFormConfig';
import CookieUtils from '../../../framework/utils/CookieUtils';
import GoogleTagManager from '../../../services/GoogleTagManager';
import UserActionsContactAPI from '../../../services/UserActionsContactAPI';
import { clearAttemptId, getOrCreateAttemptId, submitWithResolution } from '../../../services/leadAttempt';
import { history } from '../../../AppRouter';
import styles from './modals.styl';
import { toJSTransformer } from 'framework/utils/CommonUtils';
// RS-8: offer requests currently on their way, per car. sendRequestOffer is reached from several
// call sites (CTA, checkout modal, login and registration callbacks), and this component's own
// isLoading state is never read, so a second call while the first is in flight would send a second
// request. Module level, so it also covers two mounted instances.
const offerRequestsInFlight = new Set();
let OfferRequestButtonWrapper = class OfferRequestButtonWrapper extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "sendInvalidDataContactForm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (form, subCategory, needValidation = true, isValid, isSubmitted) => {
                const { carId, dealerId = null, profileStore: { userProfile, submitInvalidContactFormInformation }, authStore: { isAuthorized, userId } } = this.props;
                const category = 'offerRequest';
                const requestUserId = isAuthorized ? userId : null;
                const cookieId = CookieUtils.resolveCookieId() || null;
                const formData = {};
                if (form) {
                    if (needValidation) {
                        form.validate();
                    }
                    form.each((field) => {
                        if (field.path !== field.name)
                            return;
                        if (field.name === 'agreement') {
                            formData[field.name] = field.value;
                            return;
                        }
                        const value = field.hasNestedFields ? field.$output(field.value) : field.values();
                        // composite fields (e.g. phoneMain) carry a non-empty default (country-code dropdown), so
                        // both the field's own isEmpty and isDefault getters compare the aggregated {countryCode,
                        // areaCode, phoneNumber} object and never match — check each sub-field's isDefault instead
                        let isUntouched = field.isEmpty;
                        if (field.hasNestedFields) {
                            isUntouched = true;
                            field.each((child) => { if (!child.isDefault)
                                isUntouched = false; });
                        }
                        formData[field.name] = field.isValid
                            ? value
                            : isUntouched
                                ? 'invalid'
                                : `invalidValue - ${value}`;
                    });
                }
                const submitData = {
                    carId,
                    cookieId,
                    dealerId,
                    category,
                    subCategory,
                    requestUserId,
                    ...formData,
                    submitButton: false
                };
                if (isValid) {
                    submitData.success = true;
                }
                if (!submitData.email) {
                    submitData.email = userProfile.email;
                }
                if (isSubmitted) {
                    submitData.submitButton = true;
                }
                submitInvalidContactFormInformation(submitData);
            }
        });
        Object.defineProperty(this, "showUpdateProfileModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, authStore: { isAuthorized }, profileStore: { tempPassword, userProfile, clearTempPassword }, appStore: { showModal } } = this.props;
                showModal('UPDATE_PROFILE_MODAL', {
                    t,
                    isAuthorized,
                    tempPassword,
                    userProfile,
                    // hotjar: getInitializedHotjar(),
                    onSuccess: () => {
                        clearTempPassword();
                        this.hideUpdateProfileModal();
                        this.showThankYouModal();
                    },
                    onError: () => {
                        this.sendInvalidDataContactForm(updateProfileForm, 'updateProfile', false);
                    },
                    onClose: () => {
                        this.sendInvalidDataContactForm(updateProfileForm, 'updateProfile');
                        this.hideUpdateProfileModal();
                        this.showThankYouModal();
                    }
                });
            }
        });
        Object.defineProperty(this, "showLoginRegistrationModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, authStore: { isDealer, isSale }, profileStore, appStore: { showModal, language }, carStore, financingStore: { getOfferIndex } } = this.props;
                const carObj = toJS(carStore.car);
                const { _id, metaData: { mainImageId, ownerId }, mainData: { make, model, subModel }, price: { vatRate, mlCurrentSalesPricePredicted } } = carObj;
                // ADV-250: guest checkout entry (auth-gated before showOnlineCheckout) — same missing
                // offerIndex as showOnlineCheckout above.
                const state = { mainImageId, make, model, subModel, ownerId, vatRate, mlCurrentSalesPricePredicted, carId: _id, offerIndex: getOfferIndex() };
                const { car } = carStore;
                const isAlternativeType = !!car.metaData && !!car.metaData.type;
                showModal('LOGIN_REGISTRATION_MODAL', {
                    t,
                    // hotjar: getInitializedHotjar(),
                    isSale,
                    isAlternativeType,
                    isCheckoutViewModal: true,
                    isDynamicTitle: true,
                    className: styles.modalOverlay,
                    language,
                    onSuccessRegistration: () => {
                        if (!isSale) {
                            this.sendInvalidDataContactForm(registerForm, 'register', false, true);
                            this.sendRequestOffer(null, true)
                                .then(() => {
                                this.hideLoginRegistrationModal();
                                this.showOnlineCheckout();
                            });
                        }
                        else {
                            this.sendRequestOffer()
                                .then(() => {
                                this.hideLoginRegistrationModal();
                                this.showThankYouModal();
                            });
                        }
                    },
                    onRedirectRegistration: () => {
                        this.sendInvalidDataContactForm(registerForm, 'register', false, true);
                        // this.hideLoginRegistrationModal();
                        // this.sendRequestOffer();
                        this.sendRequestOffer()
                            .then(() => {
                            this.hideLoginRegistrationModal();
                            history.push(`${this.props.checkoutBase || '/checkout'}/contact-information`, state);
                        });
                    },
                    onSuccessLogin: () => {
                        this.sendRequestOffer()
                            .then(() => {
                            this.hideLoginRegistrationModal();
                            // if (!profileStore.hasProfileCompleted && !isDealer) {
                            //   this.showUpdateProfileModal();
                            // } else {
                            //   this.showThankYouModal();
                            // }
                            this.showThankYouModal();
                        });
                    },
                    onRedirectLogin: () => {
                        this.sendRequestOffer()
                            .then(() => {
                            this.hideLoginRegistrationModal();
                            history.push(`${this.props.checkoutBase || '/checkout'}/contact-information`, state);
                        });
                    },
                    onErrorRegistration: (reason) => {
                        if (reason && reason.id) {
                            this.sendInvalidDataContactForm(registerForm, 'register', false, true, true);
                            this.sendRequestOffer(reason.id);
                        }
                        else {
                            this.sendInvalidDataContactForm(registerForm, 'register', false, false, true);
                        }
                    },
                    onErrorLogin: () => {
                        this.sendInvalidDataContactForm(loginForm, 'login', false);
                    },
                    onCloseRegistration: () => {
                        this.sendInvalidDataContactForm(registerForm, 'register');
                        this.hideLoginRegistrationModal();
                        this.showThankYouModal();
                    },
                    onCloseLogin: () => {
                        this.sendInvalidDataContactForm(loginForm, 'login');
                        this.hideLoginRegistrationModal();
                        // this.showThankYouModal();
                    },
                    onResetPassword: () => {
                        this.hideLoginRegistrationModal();
                        this.showResetPasswordModal();
                    }
                });
            }
        });
        Object.defineProperty(this, "showResetPasswordModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, appStore: { showModal } } = this.props;
                showModal('PASSWORD_RESET_MODAL', {
                    t,
                    isCheckoutViewModal: true,
                    className: styles.modalOverlay,
                    title: t('offerRequest.passwordResetTitle'),
                    onSuccess: () => {
                        this.hideResetPasswordModal();
                        this.showResetPasswordConfirmModal();
                    },
                    onClose: () => {
                        this.hideResetPasswordModal();
                    }
                });
            }
        });
        Object.defineProperty(this, "showResetPasswordConfirmModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, appStore: { showModal } } = this.props;
                showModal('PASSWORD_RESET_CONFIRM_MODAL', {
                    t,
                    className: styles.modalOverlay,
                    onSuccess: () => {
                        this.hideResetPasswordConfirmModal();
                        this.showLoginRegistrationModal();
                    },
                    onClose: () => {
                        this.hideResetPasswordConfirmModal();
                    }
                });
            }
        });
        Object.defineProperty(this, "hideOnlineCheckoutModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { appStore: { hideModal } } = this.props;
                hideModal('ONLINE_CHECKOUT_MODAL');
            }
        });
        Object.defineProperty(this, "showOnlineCheckout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, appStore: { showModal, language }, authStore: { isAuthorized }, profileStore: { userProfile, clearTempPassword, tempPassword }, carStore, financingStore: { getOfferIndex } } = this.props;
                const carObj = toJS(carStore.car);
                const { _id, metaData: { mainImageId, ownerId }, mainData: { make, model, subModel }, price: { vatRate, mlCurrentSalesPricePredicted } } = carObj;
                // ADV-250: this is the first-time-entry path (no prior checkoutList/requestedOffers record
                // for this car) — offerIndex was missing here entirely, so a brand-new "To checkout" click
                // from the VDP's Leasing/Kaufen tab always landed on step 2 with Finanzierung preselected.
                const state = { mainImageId, make, model, subModel, ownerId, vatRate, mlCurrentSalesPricePredicted, carId: _id, offerIndex: getOfferIndex() };
                const baseContactInfo = _pick(userProfile.privateAddress, ['firstName', 'lastName', 'phoneMain']);
                const addressAdditional = _pick(userProfile.privateAddress, ['zip', 'city', 'street', 'number']);
                const carObject = toJS(carObj) || {};
                const decoratedProps = carObject;
                const engineType = decoratedProps.consumption && decoratedProps.consumption.fuel;
                showModal('ONLINE_CHECKOUT_MODAL', {
                    t,
                    addressAdditional,
                    baseContactInfo,
                    isAuthorized,
                    // hotjar: getInitializedHotjar(),
                    isCheckoutViewModal: true,
                    className: styles.modalOverlay,
                    titleClassName: styles.titleCheckout,
                    contentClassName: styles.checkoutFormContent,
                    title: t('CheckoutPage:onlineCheckoutModal.title'),
                    language,
                    engineType,
                    tempPassword,
                    onSuccess: () => {
                        this.sendRequestOffer(null, true)
                            .then(() => {
                            clearTempPassword();
                            this.hideOnlineCheckoutModal();
                            this.showThankYouModal();
                        });
                    },
                    onError: () => {
                        this.sendInvalidDataContactForm(updateProfileForm, 'updateProfile', false);
                    },
                    onRedirect: () => {
                        this.sendRequestOffer(null, true);
                        history.push(`${this.props.checkoutBase || '/checkout'}/contact-information`, state);
                    },
                    onCloseModal: () => {
                        this.sendRequestOffer(null, true)
                            .then(() => {
                            clearTempPassword();
                            this.hideOnlineCheckoutModal();
                            // this.showThankYouModal();
                        });
                    }
                });
                this.sendRequestOffer();
            }
        });
        Object.defineProperty(this, "hideUpdateProfileModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { appStore: { hideModal } } = this.props;
                hideModal('UPDATE_PROFILE_MODAL');
            }
        });
        Object.defineProperty(this, "hideLoginRegistrationModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { appStore: { hideModal } } = this.props;
                hideModal('LOGIN_REGISTRATION_MODAL');
            }
        });
        Object.defineProperty(this, "hideResetPasswordModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { appStore: { hideModal } } = this.props;
                hideModal('PASSWORD_RESET_MODAL');
            }
        });
        Object.defineProperty(this, "hideResetPasswordConfirmModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { appStore: { hideModal } } = this.props;
                hideModal('PASSWORD_RESET_CONFIRM_MODAL');
            }
        });
        Object.defineProperty(this, "showThankYouModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, carStore: { car }, appStore: { showModal, hideModal }, financingStore: { requestedOffers } } = this.props;
                if (requestedOffers.has(car._id)) {
                    // if (!!car._id) {
                    showModal('OFFER_REQUEST_THANKS_MODAL', {
                        t,
                        hideModal,
                        showModal,
                        // hotjar: getInitializedHotjar(),
                        className: styles.modalOverlay,
                        isCheckoutViewModal: true,
                        title: t('modals:offerRequest.thanks')
                    });
                }
            }
        });
        Object.defineProperty(this, "sendRequestOffer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (userID, isSendExpandedContact) => {
                const { t, financingConfig: configFromFinancing, carStore, notificationStore, financingStore: { setRequestedOffer, getOfferIndex, getUserConfig }, profileStore: { userProfile }, filterStore, checkoutStore, authStore: { isSale, userId, isAuthorized } } = this.props;
                const offerIndex = getOfferIndex();
                const carId = this.props.carId || _get(carStore, 'car._id') || configFromFinancing.carId;
                const financingConfig = carId ? getUserConfig(carId) : configFromFinancing;
                // const isOfferRequested = requestedOffers.has(carId);
                const lastSearchString = toJS(filterStore.lastSearchString);
                const marketingCookies = Cookies.get('marketing') || null;
                const { email } = registerForm.values();
                const currentSalesPriceExtra = _get(financingConfig, 'buy.currentSalesPriceExtra');
                const offerData = {
                    ...isSale ? { customerEmail: email } : '',
                    offerIndex,
                    carId,
                    lastSearchString,
                    financingConfig,
                    callBackRequest: registerForm.$('timestamp').value
                };
                if (isSendExpandedContact)
                    return Promise.resolve();
                // RS-8: a request for this car is already on its way: do not send a second one
                if (carId && offerRequestsInFlight.has(carId))
                    return Promise.resolve();
                if (!!marketingCookies)
                    offerData.marketing = { ...JSON.parse(marketingCookies), _ga: Cookies.get('_ga') || null };
                if (lastSearchString) {
                    offerData.lastSearchString = lastSearchString;
                }
                this.setState({ isLoading: true });
                // Use authStore userId to call the public /expanded-contact/{userId} endpoint
                // instead of the firebase-secured /expanded-contact, avoiding token race conditions
                // after fresh registration where the JWT may not be propagated yet.
                const effectiveUserID = userID || (!isSale ? userId : null);
                let action;
                if (!!effectiveUserID) {
                    action = carStore.submitOfferRequestByID;
                }
                else if (isSale) {
                    action = carStore.submitOfferRequestForCustomers;
                }
                else {
                    action = carStore.submitOfferRequest;
                }
                // RS-8: one attemptId per offer-request intent (this car, this tab), reused on a retry. The sale
                // path (sale/expanded-contact) has no server-side guard and keeps its old behaviour.
                const attemptScope = `offer_request:${carId}`;
                const attemptId = !isSale && carId ? getOrCreateAttemptId(attemptScope) : undefined;
                if (attemptId)
                    offerData.attemptId = attemptId;
                if (carId)
                    offerRequestsInFlight.add(carId);
                const send = () => action(offerData, !!effectiveUserID ? effectiveUserID : null);
                const sending = attemptId
                    ? submitWithResolution(attemptId, send, (aid) => UserActionsContactAPI.getAttemptStatus(aid))
                    : send();
                return sending
                    .then((data) => {
                    // confirmed: the next request for this car is a new intent
                    if (attemptId)
                        clearAttemptId(attemptScope);
                    const { currentSalesPrice } = toJSTransformer(financingConfig);
                    setRequestedOffer(carId);
                    // the request starts the customer's checkout of the car: the dashboard offers to finish it
                    // and lists the car as an order (Bestellstatus), as any checkout in progress
                    if (!isSale && isAuthorized && carId)
                        checkoutStore.saveRequestedCheckout(carId, financingConfig, offerIndex);
                    GoogleTagManager.pushOfferRequestEvent(carId, currentSalesPriceExtra, userProfile.email);
                    const carObj = toJS(carStore.car);
                    if (!!Object.keys(carObj).length)
                        GoogleTagManager.pushOfferRequestPurchaseEvent(carObj, financingConfig);
                    filterStore.clearLastSearchString();
                    const reqNumber = _get(data, 'data.reqNumber', '');
                    if (reqNumber) {
                        const getNum = reqNumber.slice(3);
                        window.open(`${_get(config, 'odoo.reqNumber')}${getNum}`, '_blank');
                    }
                    // if (typeof window.AWIN !== 'undefined' && window.AWIN.Tracking.AdvertiserConsent && currentSalesPrice) {
                    //   window.AWIN.Tracking.Sale.channel = 'aw';
                    //   window.AWIN.Tracking.Sale.currency = 'EUR';
                    //   window.AWIN.Tracking.Sale.voucher = '';
                    //   window.AWIN.Tracking.Sale.test = '0';
                    //   window.AWIN.Tracking.Sale.amount = currentSalesPrice;
                    //   window.AWIN.Tracking.Sale.orderRef = `${_get(carObj, 'metaData.vehicleId', carId)}-${userId}`;
                    //   window.AWIN.Tracking.Sale.parts = `DEFAULT:${window.AWIN.Tracking.Sale.amount}`;
                    //   window.AWIN.Tracking.run();
                    //   const awPixel = new Image(0, 0);
                    //   awPixel.src = 'https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=53781&amount=' +
                    //     parseFloat(window.AWIN.Tracking.Sale.amount).toFixed(2) +
                    //     '&ch=' + window.AWIN.Tracking.Sale.channel + `&parts=DEFAULT:` +
                    //     parseFloat(window.AWIN.Tracking.Sale.amount).toFixed(2) + '&ref=' +
                    //     window.AWIN.Tracking.Sale.orderRef + '&vc=' + window.AWIN.Tracking.Sale.voucher +
                    //     '&cr=' + window.AWIN.Tracking.Sale.currency + '&testmode=0';
                    // }
                })
                    .catch(() => {
                    notificationStore.addNotification({
                        message: t('offerRequest.sendOfferRequestFailed'),
                        level: 'error'
                    });
                })
                    .then(() => {
                    if (carId)
                        offerRequestsInFlight.delete(carId);
                });
                // .finally(() => {
                //   this.setState({
                //     isLoading: false
                //   });
                // });
            }
        });
        Object.defineProperty(this, "onClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, isOverview, notificationStore: { addNotification }, carStore: { car: { _id, metaData: { type, mainImageId, ownerId } = {}, mainData: { model, subModel, make } = {}, price: { vatRate, mlCurrentSalesPricePredicted } = {} }, importAlternative }, authStore: { isAuthorized, isSale, isAlternative, checkoutData }, financingStore: { requestedOffers, checkoutList, getUserConfig, getOfferIndex }, checkoutStore: { stepHasError, activeStep, subStep, setShowButtonErrorMessage, revealOrderOverviewTermsErrors } } = this.props;
                const isAlternativeType = !!type;
                const isSuccess = checkoutData?.isSuccess;
                // offerIndex: whichever mode (Finanzierung/Leasing/Barzahlung) is CURRENTLY selected on the
                // VDP right now (financingStore.offerIndex, kept live by the VDP's own tab onModeChange) —
                // carried through so re-entering an existing saved checkout (checkoutList.has(_id) below)
                // reflects the mode just picked, instead of CheckoutPage silently falling back to whatever
                // mode an EARLIER, possibly abandoned checkout attempt for this car was left on.
                const state = { mainImageId, make, model, subModel, ownerId, vatRate, mlCurrentSalesPricePredicted, carId: _id, offerIndex: getOfferIndex() };
                // if (requestedOffers.has(_id) && !isOverview) return; // stop executing if already had an order request
                if (isAlternative && isAuthorized && isAlternativeType) {
                    importAlternative(_id, {
                        currentSalesPrice: getUserConfig(_id).common.currentSalesPrice,
                        ownerId: _get(config, 'alternativeCarsAPI.ownerId') // xo1ag9JooQebXhnfSclw3NhZyG63
                    }).then((_id) => {
                        if (!!_id)
                            window.open(`/search/vehicle/${_id}`, '_blank');
                        else
                            addNotification({ message: t('Notifications:errors.carNotImported'), level: 'error' });
                    });
                    return;
                }
                if (!isAuthorized || isSale) {
                    this.showLoginRegistrationModal();
                    return;
                }
                else if (isSuccess) {
                    window.location.href = '/account/dashboard';
                }
                else if (isOverview && stepHasError(activeStep, subStep)) {
                    revealOrderOverviewTermsErrors();
                    setShowButtonErrorMessage(true);
                    return;
                } // last checkout step submit (return if stepHasError = true)
                else if (isOverview)
                    this.showCongratulations(); // last checkout step submit
                else if (checkoutList.has(_id))
                    history.push(`${this.props.checkoutBase || '/checkout'}/contact-information?carId=${_id}&isSavedCheckout=true&mainImageId=${mainImageId}&model=${model}&subModel=${subModel}&make=${make}`, state); // continue checkout step
                else if (requestedOffers.has(_id))
                    history.push(`${this.props.checkoutBase || '/checkout'}/contact-information`, state); // this.showOnlineCheckout(); // car is already requested
                else
                    this.showOnlineCheckout();
            }
        });
        Object.defineProperty(this, "showCongratulations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { t, mainImageTransparent, appStore: { showModal }, buyNowInvalid, step, isOverview, profileStore: { userProfile }, } = this.props;
                if (!isOverview) {
                    // Non-checkout "request an offer" flow (VDP etc.) — unchanged, still the modal: this
                    // isn't a placed order, so it doesn't belong on the checkout "06 Danke" step page.
                    this.sendRequestOffer();
                    showModal('CONGRATULATIONS_CHECKOUT_MODAL', {
                        t,
                        // hotjar: getInitializedHotjar(),
                        mainImageTransparent,
                        email: userProfile.email,
                        showCloseButton: false,
                        isCheckoutViewModal: true,
                        isDynamicTitle: true,
                        // plain literal, not a modals.styl CSS-module class — md3.css (libs/packages/
                        // fe-ui-core-autobahn) targets this by its literal name, and CSS-module hashing would
                        // break that selector match.
                        className: 'cgz-modal',
                    });
                }
                else {
                    // order-overview's "Jetzt kaufen" — a real routed page now (Figma 64637:37033, "CHECKOUT |
                    // 06 Danke"), not a modal. location.state carries the display-only data the page needs
                    // (CheckoutThankYouPage.tsx); nothing else reads it back off history.
                    history.push('/checkout/danke', { mainImageTransparent, email: userProfile.email });
                }
                buyNowInvalid(step);
            }
        });
        Object.defineProperty(this, "onBuyClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { authStore, profileStore, isOverview } = this.props;
                const { isAuthorized, isDealer } = authStore;
                const { hasProfileCompleted } = profileStore;
                if (!isOverview) {
                    this.sendRequestOffer()
                        .then(() => {
                        if (!hasProfileCompleted && !isDealer) {
                            this.showUpdateProfileModal();
                        }
                        else {
                            this.showCongratulations();
                        }
                    });
                }
                else {
                    if (!hasProfileCompleted && !isDealer) {
                        this.showUpdateProfileModal();
                    }
                    else {
                        this.showCongratulations();
                    }
                }
            }
        });
        this.state = {
            isLoading: false
        };
    }
    componentWillUnmount() {
        this.setState({ isLoading: false });
    }
    render() {
        const { children, carStore, authStore, profileStore, financingStore, checkoutStore } = this.props;
        const carId = this.props.carId || _get(carStore, 'car._id');
        const isAlternative = _get(carStore, 'metaData.type', null);
        const isOfferRequested = financingStore.requestedOffers.has(carId);
        const hasCheckout = financingStore.checkoutList.has(carId);
        const financingConfig = financingStore.getUserConfig(carId);
        const isSuccess = authStore.checkoutData?.isSuccess;
        const { isAuthorized, isSale } = authStore;
        const isLoading = authStore.isAuthFetching || profileStore.profileLoading || !(financingConfig.financing.monthlyInstallment > 0);
        return children(this.onClick, isOfferRequested, hasCheckout, isAuthorized, isLoading, isSale, isAlternative, isSuccess);
    }
};
OfferRequestButtonWrapper = __decorate([
    inject('carStore', 'appStore', 'authStore', 'notificationStore', 'profileStore', 'financingStore', 'filterStore', 'checkoutStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], OfferRequestButtonWrapper);
export default translate(['modals', 'CheckoutPage'])(OfferRequestButtonWrapper);
